import { DynamicObject } from "../types";

export function getColourMap(
  value: number,
  bound1: number,
  bound2: number,
): string {
  if (bound1 === bound2) return "#ffffff";

  if (bound1 < bound2) {
    value = Math.min(bound2, Math.max(bound1, value));
  } else {
    value = Math.max(bound2, Math.min(bound1, value));
  }

  const normalized = (value - bound1) / (bound2 - bound1);

  const colours = [
    { r: 34, g: 197, b: 94 },
    { r: 234, g: 179, b: 8 },
    { r: 239, g: 68, b: 68 },
  ];

  let r, g, b;

  if (normalized <= 0.5) {
    const factor = normalized * 2;
    r = Math.round(colours[0].r + (colours[1].r - colours[0].r) * factor);
    g = Math.round(colours[0].g + (colours[1].g - colours[0].g) * factor);
    b = Math.round(colours[0].b + (colours[1].b - colours[0].b) * factor);
  } else {
    const factor = (normalized - 0.5) * 2;
    r = Math.round(colours[1].r + (colours[2].r - colours[1].r) * factor);
    g = Math.round(colours[1].g + (colours[2].g - colours[1].g) * factor);
    b = Math.round(colours[1].b + (colours[2].b - colours[1].b) * factor);
  }
  return `rgb(${r}, ${g}, ${b})`;
}

export function revertReplaceNulls(data: DynamicObject) {
  for (const key in data) {
    if (data[key] === "NULL") {
      data[key] = null;
    } else if (typeof data[key] === "object") {
      revertReplaceNulls(data[key] as DynamicObject);
    }
  }
}

export function removeNulls(data: DynamicObject) {
  for (const key in data) {
    if (data[key] === null) {
      delete data[key];
    } else if (typeof data[key] === "object") {
      removeNulls(data[key] as DynamicObject);
    }
  }
}

export function mergeObjects(a: DynamicObject | null, b: DynamicObject | null) {
  if (b === null) {
    return null;
  }

  if (a === null) {
    a = {};
  }

  for (const key in b) {
    if (b[key] === null) {
      a[key] = null;
    } else if (typeof a[key] === "object" && typeof b[key] === "object") {
      a[key] = mergeObjects(a[key] as DynamicObject, b[key] as DynamicObject);
    } else if (a[key] !== b[key]) {
      a[key] = b[key];
    }
  }

  return a;
}

// Per the V2 timing feed protocol, a null value for an existing key means the
// leaf should be removed, not set to null.
export function mergeObjectsV2(
  a: DynamicObject | null,
  b: DynamicObject | null,
) {
  if (b === null) {
    return null;
  }

  if (a === null) {
    a = {};
  }

  for (const key in b) {
    if (b[key] === null) {
      delete a[key];
    } else if (typeof a[key] === "object" && typeof b[key] === "object") {
      a[key] = mergeObjectsV2(a[key] as DynamicObject, b[key] as DynamicObject);
    } else if (a[key] !== b[key]) {
      a[key] = b[key];
    }
  }

  return a;
}
